/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export const en = {
  'auth': {
    'username': 'Username',
    'password': 'Password',
    'login': 'Login',
    'login-details': 'Login details',
    'password-recovery-request-link': 'Forgot your password?',
    'error': {
      'Bad credentials': 'Wrong username or password!',
      'expired-user': 'The user has expired!',
      'disabled-user': 'The user email has not been confirmed!'
    },
    'resend-email-confirmation':{
      'title': 'Resend email confirmation',
      'success': 'The confirmation email was successfully sent',
      'error': 'Could not send confirmation email',
      '504': 'We are sorry, but authentication is not possible at the moment!'
    },
    'profileInfoChanged': 'Profile details updated successfully! Please login in order for the changes to be visible.'
  }
};
